import { FC } from "react";

import {
  EventGuestlistBlock,
  EventInfoBlock,
  EventPeopleBlock,
  EventScheduleBlock,
  EventTravelBlock,
  EventVenueBlock,
  ScheduleFilterType,
} from "Bands/containers";
import { EventAccommodationBlock } from "Bands/containers/EventAccommodationBlock/EventAccommodationBlock";
import { EventBlockTeaser } from "Bands/containers/EventBlock/style";
import {
  EventBlocks as EventBlocksType,
  EventUniqueBlocks,
  IEventBlock,
} from "Bands/types";
import { Card } from "shared/components";
import { useScrollToHashOnFirstRender } from "shared/utils";
import { StyledEventBlockWrapper } from "./style";

interface EventBlockProps {
  blocks: IEventBlock[];
  showPersonalInfo?: boolean;
  showActions?: boolean;
  isPrint?: boolean;
  filterType?: ScheduleFilterType;
}

export const EventBlocks: FC<EventBlockProps> = ({
  blocks,
  showPersonalInfo,
  showActions,
  isPrint,
  filterType,
}) => {
  useScrollToHashOnFirstRender();

  const renderBlockContent = (block: IEventBlock) => {
    switch (block.type) {
      case EventUniqueBlocks.people:
        return <EventPeopleBlock blockId={block.id} />;
      case EventBlocksType.schedule:
        return (
          <EventScheduleBlock blockId={block.id} filterType={filterType} />
        );
      case EventBlocksType.infoBlock:
      case EventBlocksType.infoBlockType:
        return <EventInfoBlock blockId={block.id} />;
      case EventUniqueBlocks.venue:
        return <EventVenueBlock blockId={block.id} />;
      case EventBlocksType.guestlist:
        return (
          <EventGuestlistBlock blockId={block.id} showActions={showActions} />
        );
      case EventBlocksType.travel:
        return (
          <EventTravelBlock
            blockId={block.id}
            showPersonalInfo={showPersonalInfo}
            isPrint={isPrint}
          />
        );
      case EventBlocksType.accommodation:
        return (
          <EventAccommodationBlock
            blockId={block.id}
            showPersonalInfo={showPersonalInfo}
            isPrint={isPrint}
          />
        );
      default:
        return block.type;
    }
  };

  return (
    <>
      {blocks?.map((block) => {
        const { id, title, icon, type, actions } = block;

        return (
          <Card
            key={id}
            id={id}
            title={title}
            icon={icon}
            actionDataTestId={`${type}_block_actions`}
            actions={actions}
          >
            <StyledEventBlockWrapper>
              <EventBlockTeaser>{renderBlockContent(block)}</EventBlockTeaser>
            </StyledEventBlockWrapper>
          </Card>
        );
      })}
    </>
  );
};
